import styled, { css } from 'styled-components';

import { color, media, spacing, typography } from '~/theme';

export const FieldLegend = styled.legend<{ size: 'default' | 'large' }>`
    color: ${color.palette.black};
    display: block;
    font-family: ${typography.fontSecondary};
    font-weight: ${typography.fontWeightBold};
    margin: 0 0 ${spacing.spacing3} 0;
    width: 100%;

    ${props =>
        props.size === 'default'
            ? css`
                  font-size: 1.125rem;
                  line-height: 1.56;

                  @media ${media.small} {
                      font-size: 1.1875rem;
                      line-height: 1.5;
                  }
              `
            : css`
                  font-size: 1.4375rem;
                  line-height: 1.39;

                  @media ${media.small} {
                      font-size: 1.75rem;
                      letter-spacing: 0.02rem;
                      line-height: 1.2;
                  }

                  h1,
                  h2,
                  h3,
                  h4,
                  h5,
                  h6 {
                      display: inline;
                      font-size: inherit;
                      margin: 0;
                  }
              `};
`;

export const RequiredFlag = styled.span`
    font-family: ${typography.fontPrimary};
    font-size: 1rem;
    font-weight: ${typography.fontWeightRegular};
`;

export default { FieldLegend, RequiredFlag };
